// UI texts: survivor
export default {
  /** 4. 10. 2026 (package 3, G): the Veteran Ledger. */
  ledger: {
    title: 'Veteran Ledger',
    link: 'Veteran Ledger',
    linkLine: '{n} Marks to spend',
    linkLocked: 'Opens at level {n}',
    intro: 'For this season: Marks from your Survivor Ranks, achievements and Collection book milestones (every 25 fields). Nothing here touches energy, Power or fights. It starts over with the season; your rank stays.',
    marks: '{n} Marks to spend',
    from: 'Earned this season: {ranks} from ranks, {ach} from achievements, {book} from book milestones',
    spent: '{n} spent',
    level: 'Level {n}/{max}',
    buy: 'Buy · {n}',
    top: 'Top',
    locked: 'The Ledger opens at level {n}.',
    bought: '{name}: level {n}',
    short: '{n} more Marks',
  },
  power: 'Power',
  pending: '+{n} pending',
  currentGear: 'current gear',
  tapSlot: 'Tap a slot to swap',
  empty: 'Empty',
  locked: 'Later',
  comingSoon: 'Coming soon',
  lockedSlot: '{slot}: coming soon',
  /** Package 4, part E: worn slots locked against a winner. */
  locks: {
    line: 'Locked slots: {n} of {max}. A survivor who beats you on a run can take one item from the others. The Barricade lets you lock more.',
    /** 23. 10. 2026 (owner, a player's feedback): the free locks fill on their own. */
    lineAuto: 'Locked slots: {n} of {max}, {auto} on their own: your strongest worn items. A survivor who beats you on a run can take one item from the others. The Barricade lets you lock more.',
    autoTip: 'Locked on its own: one of your strongest worn items. Tap to keep it locked whatever you wear.',
    keep: 'Keep the {slot} slot locked',
    lock: 'Lock the {slot} slot',
    unlock: 'Unlock the {slot} slot',
    lockedTip: 'Locked: a winner never takes this item.',
    openTip: 'Lock it: a winner never takes this item.',
    fullTip: 'All your locks are used. The Barricade lets you lock more.',
  },
  figureAlt: '{name}, your survivor',
  picker: {
    title: '{slot}',
    worn: 'Worn now',
    nothingWorn: 'Nothing in this slot.',
    none: 'No {slot} in Storage. Expeditions bring new gear.',
    /** Krug 5 (K4.13). */
    best: 'Best',
    /** 30. 9. 2026: the survivor's Power with this item on. */
    power: 'Power {pct}',
    setLine: '{name} set {n}/5',
    kg: '{n} kg',
    durability: 'Durability {n}/{max}',
    setLose: '{name} {from}/5 → {to}/5: you lose {what}',
    setGain: '{name} {from}/5 → {to}/5: {what}',
    /** 6. 10. 2026: a set whose pieces change without reaching or breaking a threshold. */
    setMove: '{name} set {from}/5 → {to}/5',
  },
  broken: 'Broken',
  durability: 'Durability {n}%',
  openSlot: '{slot}: {name}',
  /** The set mark, read out (26. 9. 2026). */
  setOn: '{name} set {n}/5, active',
  setOff: '{name} set {n}/5, not active yet',
  openEmptySlot: '{slot}: empty, open inventory',
  slot: {
    weapon: 'Weapon',
    helmet: 'Helmet',
    body: 'Body',
    pants: 'Pants',
    boots: 'Boots',
    backpack: 'Backpack',
    gloves: 'Gloves',
    accessory: 'Accessory',
  },
  stat: {
    hp: 'HP',
    attack: 'Attack',
    defense: 'Defense',
    capacity: 'Capacity',
    crit: 'Crit',
    accuracy: 'Accuracy',
    escape: 'Escape',
    stealth: 'Stealth',
    loot: 'Loot',
    detect: 'Detect',
    dodge: 'Dodge',
    craftSpeed: 'Craft speed',
  },
  statsTitle: 'Field numbers',
  breakdown: {
    title: 'Where {stat} comes from',
    total: 'Total',
    nothing: 'Nothing changes this yet.',
    negative: 'Red parts pull the number down. Swap or drop that piece to lose the penalty.',
    open: 'Show where {stat} comes from',
  },
  load: {
    title: 'Load',
    detail: 'Worn gear {w} of {max} (10 + 0.7 × STR)',
    state: { light: 'Light', normal: 'Normal', heavy: 'Heavy', overloaded: 'Overloaded', blocked: 'Too heavy' },
    effects: {
      light: '+5% escape chance',
      normal: 'No effect',
      heavy: '−5% escape, −2% dodge, −5% initiative',
      overloaded: '−15% escape, −6% dodge, −15% initiative, +10% expedition time',
      blocked: 'Cannot head out until something comes off',
    },
  },
  sets: {
    title: 'Sets',
    none: 'No set pieces on. Two armor pieces of the same set switch on a bonus, three and five add more.',
  },
  tags: {
    newProtection: 'New survivor protection',
    protectedUntil: 'Protected until {t}',
    wanted: 'Wanted',
  },
  levelUp: 'Level up',
  pointsAvailable: '{n} attribute points available',
  pointAvailable: '1 attribute point available',
  addPoint: 'Add a point to {a}',
  removePoint: 'Remove a point from {a}',
  gearBonus: '+{n} gear',
  gearBonusNeg: '{n} gear',
  gearBonusTitle: 'From equipped gear',
  countsAs: 'counts as {n}',
  /** Krug 5 (K4.15): under the attribute's total, "15 + 2 gear". */
  attrParts: '{own} + {n} gear',
  attrPartsNeg: '{own} − {n} gear',
  softCapTitle: 'Every point above {n} counts half',
  reset: 'Reset',
  confirm: 'Confirm',
  filed: 'Filed',
  saved: 'Points assigned.',
  attr: {
    str: { key: 'STR', name: 'Strength', desc: 'Melee damage (+1% per point), how much you can carry (+1 per point) and how much gear you can wear.' },
    /** 2. 10. 2026 (package 1, 8.g): hiding, theft and hazards too. */
    agi: { key: 'AGI', name: 'Agility', desc: 'Strike first, dodge hits and get away (+2% escape chance per point). Steal and stay hidden as a Shadow (+2% per point), and hazards hurt less (−1% per point over 15, up to −40%).' },
    int: { key: 'INT', name: 'Intelligence', desc: 'Cheaper, better crafting, cheaper repairs, better trades and more keys to secret places.' },
    vit: { key: 'VIT', name: 'Vitality', desc: 'Max HP (+20 per point) and defense (+0.5 per point).' },
    /** 8.g: more resources per search, not better items. */
    per: { key: 'PER', name: 'Perception', desc: 'Ranged damage (+1% per point), hit chance, more resources from every search (+1% per point over 15), and spotting Shadows and thieves (+2% per point).' },
  },
  /** 8.g: the event checks, the same for all five. */
  eventChecks: 'Events test all five: every point over 15 adds 2% to the checks of that attribute, every point under 15 takes 2% away.',
  /** 8.g: what one more point changes, from the same formulas as the game. */
  gain: {
    title: '+1 point',
    power: 'Power {v}',
    damage: 'damage {v}',
    carry: 'carry {v}',
    gearLimit: 'gear limit {v}',
    hp: 'max HP {v}',
    defense: 'defense {v}',
    escape: 'escape {v}',
    hazard: 'hazard damage {v}',
    steal: 'stealing and hiding {v}',
    hit: 'hit chance {v}',
    resources: 'resources {v}',
    spot: 'spotting {v}',
    repair: 'repair cost {v}',
    craft: 'craft time {v}',
    trade: 'trades {v}',
    finds: 'keys and special finds {v}',
    events: 'event checks {v}',
    nothing: 'nothing more: this one is capped',
  },
  assigned: '{n} points assigned',
  respecFree: 'Respec · free',
  respecCost: 'Respec · {n} Scrap',
  respecTitle: 'Respec attributes',
  respecBody: 'All {n} points you assigned go back into the pool. Your background bonus stays.',
  respecFirstFree: 'The first respec is free.',
  respecPrice: 'Cost: {n} Scrap. You have {have}.',
  respecNoScrap: 'Not enough Scrap.',
  respecConfirm: 'Respec now',
  respecDone: 'Points are back in the pool',
  skills: 'Skills',
  skillPoints: '{n} skill points to spend',
  skillPoint: '1 skill point to spend',
  skillsLearned: '{n} nodes learned',
  skillsLearnedOne: '1 node learned',
  openSkills: 'Open skill tree',
  record: {
    title: 'Record',
    expeditions: 'Expeditions',
    pvpWins: 'PvP wins',
    escapes: 'Escapes',
    ambushes: 'Ambushes',
    kills: 'Kills',
    trades: 'Trades',
    itemsFound: 'Items found',
    discoveries: 'Discoveries',
  },
  achievements: 'Achievements',
  achievementsCount: '{n} / {total}',
  noAchievements: 'Nothing on the wall yet',
  noAchievementsBody: 'Come back from your first expedition to earn one.',
  showLocked: 'Show locked ({n})',
  hideLocked: 'Hide locked',
  /** 9. 10. 2026 (owner): the unlocked ones under a dropdown too. */
  showUnlocked: 'Show unlocked ({n})',
  hideUnlocked: 'Hide unlocked',
  titleReward: 'Title: {t}',
  title: 'Title',
  noTitle: 'No title',
  changeTitle: 'Change title',
  earnedOn: 'Earned {d}',
  error: 'Could not load your survivor.',
  /** Link to the report history (krug 3, U2). */
  historyLine: '{n} runs · read the reports again',
  /** 20. 10. 2026 (owner): the worn gear next to the portrait (the weapon first). */
  worn: {
    label: 'Worn gear',
    weapon: 'Weapon: {name}',
    item: '{slot}: {name}',
    none: 'Nothing worn yet',
  },
  /** 20. 10. 2026 (owner): renaming the survivor (Survivor screen and Settings). */
  rename: {
    button: 'Change name',
    title: 'Change your name',
    label: 'New name',
    rule: '{min}–{max} characters: letters, numbers, spaces, - and _',
    free: 'Your first change is free. After that you can change it once every {days} days.',
    next: 'You can change your name again on {date}.',
    later: 'After this change, the next one is possible in {days} days.',
    former: 'Formerly: {names}',
    keeps: 'Fights, wanted posters and revenge still know you by your survivor, not your name.',
    save: 'Save name',
    cancel: 'Cancel',
    done: 'You are now {name}',
  },
} as const;
